import SVGIcon, { svgIconsPropTypes } from './SVGIcon'

export { svgIconsPropTypes }
export default SVGIcon
